import { Component, inject } from '@angular/core';
import { UnauthenticatedPageComponent } from '../../components/unauthenticated-page/unauthenticated-page.component';
import { UnauthenticatedForwardNavService } from '../../services/unauthenticated-forward-nav.service';

@Component({
  selector: 'app-about-future-directions',
  standalone: true,
  imports: [UnauthenticatedPageComponent],
  templateUrl: './about-future-directions.component.html',
  styleUrls: [
    '../../../../../../libs/shared/src/lib/styles/service-tiles.css',
    './about-project.component.css',
    './about-future-directions.component.css',
  ],
})
export class AboutFutureDirectionsComponent {
  readonly unauthNav = inject(UnauthenticatedForwardNavService);
  readonly pageTitle = 'Future directions';
}
